import * as React from "react";
import { NavLink } from "react-router-dom";
import { SlowFadeTransition } from "@@components/transitions";
import type { IAppCommandPromptResultGroup, IAppCommandPromptResultItem } from "./appcommandprompt";
import type { Entities } from "@inwink/entities/entities";
import { WithPopoverManager, IPopoverManager } from "@inwink/modals/popovermgr";

export interface IAppCommandResultGroupProps {
    i18nHelper: Entities.i18nHelper;
    group: IAppCommandPromptResultGroup;
    itemClicked: () => void;
}

export class AppCommandResultGroup extends React.Component<IAppCommandResultGroupProps, any> {
    render() {
        const label = this.props.i18nHelper.translate(this.props.group.label, null, this.props.group.label);
        const number = <div className="itemsnumber">
            {this.props.group.items.length} {this.props.group.hasMore ? "+" : ""}
        </div>;
        return <WithPopoverManager>
            {(popovermgr) => <SlowFadeTransition in={true}>
                <div className="command-result-group" tabIndex={-1}>
                    <div className="group-name">
                        {this.props.group.icon ? <div className="icon"><i className={this.props.group.icon} /></div> : null}
                        <div className="label" tabIndex={-1}>{label}</div>
                        <div className="right">
                            {this.props.group.moreLink ? <NavLink tabIndex={0} className="moreitems focusable"
                                to={this.props.group.moreLink} onClick={this.props.itemClicked}>
                                {number}
                                <i className="inwink-arrow-right" />
                            </NavLink> : number}
                        </div>
                    </div>
                    <div className="group-items">{this.props.group.items.map((it) => {
                        return <AppCommandResultItem
                            item={it}
                            key={it.id}
                            popovermgr={popovermgr}
                            i18nHelper={this.props.i18nHelper}
                            itemClicked={this.props.itemClicked}
                        />;
                    })}</div>
                </div>
            </SlowFadeTransition>}
        </WithPopoverManager>;
    }
}


export interface IAppCommandResultItemProps {
    popovermgr: IPopoverManager;
    i18nHelper: Entities.i18nHelper;
    item: IAppCommandPromptResultItem;
    itemClicked: () => void;
}

export class AppCommandResultItem extends React.Component<IAppCommandResultItemProps, any> {
    render() {
        if (this.props.item.component) {
            return React.createElement(this.props.item.component, this.props);
        }

        const content = this.props.item.contentComponent ? React.createElement(this.props.item.contentComponent, this.props) : <>
            {this.props.item.icon ? <div className="icon"><i className={this.props.item.icon} /></div> : null}
            <div className="detail">
                {this.props.item.sublabel ? <span className="sublabel">{this.props.item.sublabel}</span> : null}
                <span className="label">{this.props.item.label}</span>
            </div>
        </>;
        if (this.props.item.link) {
            return <NavLink tabIndex={0} className="command-result-item focusable" to={this.props.item.link} onClick={() => {
                this.props.itemClicked();
            }}>
                {content}
            </NavLink>;
        }

        return <div className="command-result-item" tabIndex={0}>
            {content}
        </div>;
    }
}